// 디바이스 타입 감지
export const detectDeviceType = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/Android/i.test(userAgent)) return 'android';
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return 'ios';
  return 'web';
};

// 앱/웹 환경에 맞게 외부 링크 처리
export const handleExternalLink = (url) => {
  const device = detectDeviceType();

  if (device === 'android') {
    window.openExternalUrl.postMessage(url);
    return;
  }

  if (window.webkit?.messageHandlers?.openExternalUrl) {
    window.webkit.messageHandlers.openExternalUrl.postMessage(url);
    return;
  }

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  if (isMobile) {
    window.location.href = url;
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};
